// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.targetPrice-container {
  /* containing block for the info panel overlay */
  position: relative;
  font-family: 'Arial', 'Helvetica', 'Sans-serif';
  cursor: auto;
  box-sizing: border-box;
  container-type: inline-size;
  width: 100%;
  height: 100%;
}

.targetPrice {
  width: 100%;
  height: 100%;

  display: flex;
  flex-direction: column;
  gap: 24px;
}

@container (min-width: 768px) {
  .targetPrice {
    flex-direction: row;

    & > div {
      flex: 1;
    }
  }
}

.targetPrice-card-container {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px 24px;
  border-radius: 2px;
  background-color: var(--surface-tertiary);
}

.targetPrice-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.targetPrice-info-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  color: var(--text-primary);
}

.targetPrice-info-button svg {
  width: 100%;
  height: 100%;
  display: block;
}

.targetPrice-card-potential-container {
  margin-top: 15px;
  margin-bottom: 15px;
  display: flex;
  gap: 4px;
  align-items: center;

  /*margin-left: auto;*/

  font-weight: 700;
  font-size: 16px;
  line-height: 100%;
}

.targetPrice-card-potential-icon-up {
  width: 24px;
  height: 24px;

  path {
    fill: var(--accent-up);
  }
}

.targetPrice-card-potential-icon-down {
  width: 24px;
  height: 24px;

  path {
    fill: var(--accent-down);
  }
}

.targetPrice-card-content {
  display: flex;
  gap: 8px;
}

.targetPrice-card-price-wrapper {
  text-align: center;
  display: flex;
  align-items: baseline;
  gap: 2px;
}

.targetPrice-card-price {
  font-family: 'Arial', 'Helvetica', 'Sans-serif';
  font-weight: 700;
  font-size: 32px;
  /* line-height: 24px; */
  letter-spacing: 0px;
  align-items: baseline;
  color: var(--text-primary);
}

.targetPrice-card-price-unit {
  font-weight: 400;
  font-size: 10px;
  line-height: 13px;
  align-items: baseline;
  letter-spacing: -0.4px;
  color: var(--text-primary);
}

.targetPrice-card-price-percentage {
  font-family: 'Arial', 'Helvetica', 'Sans-serif';
  font-weight: 700;
  font-size: 16px;
  line-height: 13px;
  text-align: center;
}

.targetPrice-card-description {
  align-self: center;
  text-align: left;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0px;
  color: var(--text-primary);
}

.targetPrice-card-potential-container .up {
  color: var(--text-up-color);
}
.targetPrice-card-potential-container .down {
  color: var(--text-down-color);
}

.targetPrice-chart-container {
  padding: 12px;
}
`, "",{"version":3,"sources":["webpack://./src/Widgets/TargetPriceWidget/TargetPriceWidget.css"],"names":[],"mappings":"AAAA;EACE,gDAAgD;EAChD,kBAAkB;EAClB,+CAA+C;EAC/C,YAAY;EACZ,sBAAsB;EACtB,2BAA2B;EAC3B,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;;EAEZ,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE;IACE,mBAAmB;;IAEnB;MACE,OAAO;IACT;EACF;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,QAAQ;EACR,mBAAmB;;EAEnB,qBAAqB;;EAErB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;;EAEZ;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,WAAW;EACX,YAAY;;EAEZ;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,+CAA+C;EAC/C,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,+CAA+C;EAC/C,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;AACA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;AACf","sourcesContent":[".targetPrice-container {\n  /* containing block for the info panel overlay */\n  position: relative;\n  font-family: 'Arial', 'Helvetica', 'Sans-serif';\n  cursor: auto;\n  box-sizing: border-box;\n  container-type: inline-size;\n  width: 100%;\n  height: 100%;\n}\n\n.targetPrice {\n  width: 100%;\n  height: 100%;\n\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n@container (min-width: 768px) {\n  .targetPrice {\n    flex-direction: row;\n\n    & > div {\n      flex: 1;\n    }\n  }\n}\n\n.targetPrice-card-container {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 12px 24px;\n  border-radius: 2px;\n  background-color: var(--surface-tertiary);\n}\n\n.targetPrice-card-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.targetPrice-info-button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  width: 24px;\n  height: 24px;\n  padding: 0;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  color: var(--text-primary);\n}\n\n.targetPrice-info-button svg {\n  width: 100%;\n  height: 100%;\n  display: block;\n}\n\n.targetPrice-card-potential-container {\n  margin-top: 15px;\n  margin-bottom: 15px;\n  display: flex;\n  gap: 4px;\n  align-items: center;\n\n  /*margin-left: auto;*/\n\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 100%;\n}\n\n.targetPrice-card-potential-icon-up {\n  width: 24px;\n  height: 24px;\n\n  path {\n    fill: var(--accent-up);\n  }\n}\n\n.targetPrice-card-potential-icon-down {\n  width: 24px;\n  height: 24px;\n\n  path {\n    fill: var(--accent-down);\n  }\n}\n\n.targetPrice-card-content {\n  display: flex;\n  gap: 8px;\n}\n\n.targetPrice-card-price-wrapper {\n  text-align: center;\n  display: flex;\n  align-items: baseline;\n  gap: 2px;\n}\n\n.targetPrice-card-price {\n  font-family: 'Arial', 'Helvetica', 'Sans-serif';\n  font-weight: 700;\n  font-size: 32px;\n  /* line-height: 24px; */\n  letter-spacing: 0px;\n  align-items: baseline;\n  color: var(--text-primary);\n}\n\n.targetPrice-card-price-unit {\n  font-weight: 400;\n  font-size: 10px;\n  line-height: 13px;\n  align-items: baseline;\n  letter-spacing: -0.4px;\n  color: var(--text-primary);\n}\n\n.targetPrice-card-price-percentage {\n  font-family: 'Arial', 'Helvetica', 'Sans-serif';\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 13px;\n  text-align: center;\n}\n\n.targetPrice-card-description {\n  align-self: center;\n  text-align: left;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  letter-spacing: 0px;\n  color: var(--text-primary);\n}\n\n.targetPrice-card-potential-container .up {\n  color: var(--text-up-color);\n}\n.targetPrice-card-potential-container .down {\n  color: var(--text-down-color);\n}\n\n.targetPrice-chart-container {\n  padding: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
